import { isNullable, isUndefined } from "../type-guards";
export function assertNotUndefined(v, message) {
    if (isUndefined(v)) {
        throw new Error(message ?? "assertion error: values is undefined");
    }
}
export function assertNotNullable(v, message) {
    if (isNullable(v)) {
        throw new Error(message ?? "assertion error: values is null or undefined");
    }
}
//# sourceMappingURL=assert-empty.js.map